import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { SURGERY_STATUS_LABELS, SURGERY_STATUS_COLORS, SURGERY_STATUS } from './constants';

const useStyles = makeStyles(() => ({
  badge: {
    fontWeight: 600,
    fontSize: '0.75rem',
    height: 24,
    borderRadius: 12,
    color: '#fff',
  },
  pulse: {
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.6 },
    '100%': { opacity: 1 },
  },
}));

const StatusBadge = ({ status, size = 'small', className = '' }) => {
  const classes = useStyles();
  const label = SURGERY_STATUS_LABELS[status] || 'Unknown';
  const bgColor = SURGERY_STATUS_COLORS[status] || '#9E9E9E';
  const isPulsing = status === SURGERY_STATUS.STARTED;

  return (
    <Chip
      label={label}
      size={size}
      className={`${classes.badge} ${isPulsing ? classes.pulse : ''} ${className}`}
      style={{ backgroundColor: bgColor }}
    />
  );
};

export default StatusBadge;
